import accordionStyles from './accordion';

var activeAccordionContent = document.querySelectorAll(".active-accordion > .accordion-content");
var accHeading = document.getElementsByClassName("accordion-heading");
var accItem = document.querySelectorAll(".accordion-item");
var i, j, accContent;

for (i = 0; i < accHeading.length; i++) {
  accHeading[i].addEventListener("click", function () {
    var classExist = this.parentElement.classList.contains("active-accordion");
    var accContent = this.nextElementSibling;
    if(classExist == false){
      for (j = 0; j < accHeading.length; j++) {
        accHeading[j].parentElement.classList.remove("active-accordion");
        var accContent1 = accHeading[j].nextElementSibling;
        accContent1 = accHeading[j].nextElementSibling;
        accContent1.style.maxHeight = null;
      }
      this.parentElement.classList.add("active-accordion");
      accContent.style.maxHeight = accContent.scrollHeight + "px";
    }else{
      this.parentElement.classList.remove("active-accordion");
      accContent.style.maxHeight = null;
    }
  });
}
